import { ReportQuarter } from "@/apis/workbook/types";

/** 보고 기간 → 당기 라벨 줄기. Q4 는 다른 화면에서도 "사업"(사업보고서)이라 연간과 같다. */
const CURRENT_STEM_BY_QUARTER: Record<ReportQuarter, string> = {
  [ReportQuarter.Q1]: "당분기",
  [ReportQuarter.Q2]: "당반기",
  [ReportQuarter.Q3]: "당분기",
  [ReportQuarter.Q4]: "당기",
  [ReportQuarter.AR]: "당기",
};

/**
 * 워크북 칸의 기간 라벨. 워크북 정보만으로 만든다 — 분기·반기는 워크북 보고 기간
 * (reportQuarter), '말'은 표의 isPeriodEnd. IXD 라벨을 빌려 쓰지 않아야 양쪽 칸을
 * 나란히 놓았을 때 차이가 그대로 보인다.
 *
 * 워크북 원문 글자가 아니라 다시 만든 라벨이다("당반기말 현재"도 "당반기말").
 * isPeriodEnd 가 null(모름)이면 '말'만 빼고 분기·반기는 보고 기간대로 적는다 — 보고
 * 기간은 워크북이 확정한 값이라 기말 여부를 몰라도 버릴 이유가 없다.
 * 기말 표의 전기는 편집기 비교표시유형 선택지('당분(반)기말,전기말')처럼 "전기말"이다.
 */
export const getWorkbookPeriodLabel = (
  period: "CURRENT" | "PRIOR",
  reportQuarter: ReportQuarter | null | undefined,
  isPeriodEnd: boolean | null | undefined,
): string => {
  const currentStem = reportQuarter
    ? CURRENT_STEM_BY_QUARTER[reportQuarter]
    : "당기";
  if (isPeriodEnd === true) {
    return period === "CURRENT" ? `${currentStem}말` : "전기말";
  }
  return period === "CURRENT" ? currentStem : currentStem.replace(/^당/, "전");
};
